// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__d4aF-","resendInfoText":"OnGoingPaymentBox_resendInfoText__1vtHu"};